var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.89 11.012C23.698 10.516 24.233 9.83897 24.495 8.97797C23.7571 9.37708 22.9652 9.6671 22.144 9.83897C21.441 9.08297 20.551 8.69897 19.484 8.69897C18.441 8.69897 17.56 9.06497 16.841 9.77697C16.4938 10.1151 16.2193 10.5205 16.0342 10.9685C15.8492 11.4164 15.7576 11.8974 15.765 12.382C15.765 12.691 15.804 12.967 15.882 13.201C12.806 13.096 10.26 11.82 8.25402 9.36397C7.91402 9.96497 7.74402 10.577 7.74402 11.21C7.74402 12.511 8.29302 13.542 9.38902 14.299C8.76402 14.246 8.21302 14.088 7.74402 13.829C7.74402 14.758 8.01702 15.534 8.56402 16.217C9.09538 16.8825 9.8442 17.3396 10.679 17.508C10.367 17.588 10.038 17.626 9.70002 17.626C9.38802 17.626 9.16702 17.6 9.03602 17.543C9.26602 18.3 9.70002 18.914 10.327 19.384C10.9469 19.8546 11.7008 20.1149 12.479 20.127C11.147 21.172 9.62402 21.689 7.90102 21.689C7.47902 21.689 7.18002 21.683 6.99902 21.651C8.69602 22.753 10.585 23.3 12.675 23.3C14.814 23.3 16.704 22.758 18.349 21.674C19.994 20.596 21.208 19.266 21.988 17.7C22.7594 16.1847 23.161 14.5083 23.16 12.808V12.34C23.879 11.8099 24.5014 11.1601 25 10.419C24.3266 10.7108 23.6169 10.9103 22.89 11.012V11.012Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/Tw.249bc50a6f484496ce27acac572f10e3.svg";
export { ForwardRef as ReactComponent };